import type { AgentMetrics, AgentStats, DateRange } from '../types/voip';

export const rangeFactor: Record<DateRange, number> = {
  today: 1 / 22,
  '7d': 5 / 22,
  '30d': 1,
};

export function scaleMetrics(m: AgentMetrics, range: DateRange): AgentMetrics {
  const f = rangeFactor[range];
  return {
    outbound: Math.round(m.outbound * f),
    inbound: Math.round(m.inbound * f),
    missed: Math.round(m.missed * f),
    talkSeconds: Math.round(m.talkSeconds * f),
  };
}

export function deriveStats(m: AgentMetrics): AgentStats {
  const connected = m.outbound + m.inbound;
  const offered = m.inbound + m.missed;
  return {
    ...m,
    connected,
    totalCalls: connected + m.missed,
    answerRate: offered === 0 ? 1 : m.inbound / offered,
    avgSeconds: connected === 0 ? 0 : Math.round(m.talkSeconds / connected),
  };
}

export function sumMetrics(list: AgentMetrics[]): AgentMetrics {
  return list.reduce(
    (acc, m) => ({
      outbound: acc.outbound + m.outbound,
      inbound: acc.inbound + m.inbound,
      missed: acc.missed + m.missed,
      talkSeconds: acc.talkSeconds + m.talkSeconds,
    }),
    { outbound: 0, inbound: 0, missed: 0, talkSeconds: 0 }
  );
}
